// eslint-disable-next-line import/no-extraneous-dependencies
import faker from 'faker';
import { Factory } from 'miragejs';
import { v4 as uuidv4 } from 'uuid';
import { TimeUtil } from '@/util/time';

export default Factory.extend({
  provider: {
    name: 'stripe',
    instance: 'canada',
  },
  fee() {
    return faker.random.number({
      min: 2,
      max: 50,
    });
  },
  evidence: {
    dueDate: '2020-09-27T23:59:59.000Z',
    submitted: false,
    details: {
      text: "The booking was done on the APP on Tuesday, June 30, 2020, at 12:49:30 PM EDT for pickup at 475 RUE PERRON, LA PRAIRIE, QC J5R 6B8, CANADA, and the destination address was VILLA-MARIA, MONTREAL, QC H4A 3K4, CANADA. The driver arrived at the pickup location at 1:17:20 PM EDT picked up the customer and reached the destination at 1:42:43 PM EDT. The fare for this trip was $52.25. The customer paid a tip of $31.35. We had done a pre-auth of $58.19 before the trip and at the end of the trip, we released the pre-auth of $58.19. At the end of the trip, we did a new capture of $83.6 from the customer's credit card. Please see attached the proof from our dispatch system that the trip status was \"COMPLETED\" and $83.6 was charged to the customer. The description on the credit card statement could be iCabbi Canada or Teo Taxi or Téo or Téo Montréal or Téo Montréal CA",
      file: 'file_1HMAu0LhB5nRslGNjbjjsUVk',
    },
  },
  disputeDate: TimeUtil.now().toISOString(),
  status: 'needs_response',
  reason: 'fraudulent',
  amount() {
    return faker.random.number({
      min: 2,
      max: 50,
    });
  },
  providerId: uuidv4(),
  booking: {
    id: uuidv4(),
    fleetId: '8a7d2e09-fb66-4e3c-9cfb-09852d9abdea',
    bookingChannelId: '182e5b91-6b3a-46ef-988f-bb2f4abe7395',
    bookingChannelName() {
      return faker.company.companyName();
    },
    dispatchId() {
      return faker.random.number({
        min: 1,
        max: 1e9,
      });
    },
    amount() {
      return faker.random.number({
        min: 2,
        max: 50,
      });
    },
    paymentSource: 'APP',
  },
  payout: {
    id: uuidv4(),
    arrivalDate: TimeUtil.now(),
  },
  transaction: {
    card: {
      brand() { return faker.random.arrayElement(['visa', 'mastercard', 'amex', 'jcb', 'unionpay']); },
    },
    date: TimeUtil.now().toISOString(),
    applicationFee() {
      return faker.random.arrayElement([0.2, 0.1, 0.5, 0.89, 0.12, 0.45]);
    },
  },
});
